<ion-content class="ion-padding">
    <app-autosave
        #autosave
        [hidden]="!canSaveReview"
        [isSaving]="autoSaving"
        [pendingChanges]="hasPendingChanges"
    ></app-autosave>

    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(reviewConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <ng-container
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration && (goals && !hasGoals(goals)) && !hideGoalsOnGoalsReview"
        >
            <ion-item lines="none" mode="ios" class="para-content">
                <ion-label class="ion-text-wrap">
                    <p class="para warning">
                        {{ 'goalsReview.goalsNotSetError' | translate }}
                    </p>
                </ion-label>
            </ion-item>
        </ng-container>

        <app-step-description
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration"
            [description]="getText( reviewConfig?.globalizationConfig, 'instructions' )"
        ></app-step-description>

        <ion-item
            lines="none"
            mode="ios"
            class="para-content"
        >
            <form
                [formGroup]="coachingForm"
                *ngIf="coachingForm && (coachingConfig?.questionsGroups?.length > 0)"
            >
                <ng-container
                    *ngFor="let group of coachingConfig.questionsGroups; let groupIndex = index"
                >
                    <ng-container *ngIf="!questionsType[QuestionType.Calculate].hidden">
                        <h4>
                            {{ (groupIndex + 1) + ' - ' + getText(group.globalizationConfig, 'title') }}
                        </h4>
                    </ng-container>
                    <app-question-types
                        *ngFor="let question of group.questions"
                        [question]="question"
                        [formGroup]="coachingForm"
                    ></app-question-types>
                </ng-container>
                <p class="rejectComment">
                    {{ coachingForm.get('managerComment').value }}
                </p>
            </form>

            <form
                [formGroup]="coachingForm"
                *ngIf="coachingForm && !(coachingConfig.questionsGroups.length > 0)"
            >
                <ng-container
                    *ngFor="let question of coachingConfig?.questions ; let index = index"
                >
                    <ng-container *ngIf="!question.hideQuestion">
                        <h4>
                            {{
                                (getVisibleQuestionIndex(question)) + ' - ' + getText(
                                    question.globalizationConfig, 'title')
                            }}
                        </h4>
                        <ng-container [ngSwitch]="question.typeConfig.type">
                            <ng-container *ngSwitchCase="QuestionType.Text">
                                <ion-textarea
                                    [readonly]="!canEdit"
                                    [formControlName]="'field' + (index + 1)"
                                    [maxlength]="question.typeConfig?.max && question.typeConfig.max > 0 ? question.typeConfig.max : 1000000"
                                ></ion-textarea>

                                <p
                                    class="charCount"
                                    [ngClass]="{ 'limitReached': coachingForm.get('field' + (index + 1)).value?.length === question.typeConfig?.max }"
                                    *ngIf="canEdit"
                                >
                                    {{
                                        coachingForm.get('field' + (index + 1)).value?.length || 0
                                    }}/{{ question.typeConfig?.max }}
                                </p>
                            </ng-container>

                            <ion-item *ngSwitchCase="QuestionType.Selection">
                                <ion-select
                                    [placeholder]="'dashboard.selectOne' | translate"
                                    [formControlName]="'field' + (index + 1)"
                                    [interfaceOptions]="{ cssClass: 'question-type-select-bg' }"
                                >
                                    <ion-select-option
                                        *ngFor="let opValue of question.typeConfig.possibleValuesGlobalized['en-US'];let vIndex = index"
                                        [value]="opValue">
                                        {{
                                            getText(question.typeConfig.possibleValuesGlobalized, vIndex)
                                                | uppercase
                                        }}
                                    </ion-select-option>
                                </ion-select>
                            </ion-item>

                            <ion-item *ngSwitchCase="QuestionType.MultiSelection">
                                <ion-select
                                    [placeholder]="'dashboard.selectOne' | translate"
                                    [interfaceOptions]="{ cssClass: 'question-type-select-bg' }"
                                    [multiple]="true"
                                    (ionChange)="onSelectChange($event, index)"
                                    [value]="coachingForm.get('field' + (index + 1)).value?.split('; ')"
                                    [disabled]="coachingForm.get('field' + (index + 1)).disabled"
                                >
                                    <ion-select-option
                                        *ngFor="let opValue of question.typeConfig.possibleValuesGlobalized['en-US'];let vIndex = index"
                                        [value]="opValue">
                                        {{
                                            getText(question.typeConfig.possibleValuesGlobalized, vIndex)
                                                | uppercase
                                        }}
                                    </ion-select-option>
                                </ion-select>
                            </ion-item>                            <ion-item [disabled]="!canEdit" *ngSwitchCase="QuestionType.Date">
                                <ion-datetime
                                    presentation="date"
                                    [locale]="'pt-BR'"
                                    [formControlName]="'field' + (index + 1)"
                                    (ionChange)="setDate($event.detail.value,index)"
                                ></ion-datetime>
                            </ion-item>

                            <ion-radio-group *ngSwitchCase="QuestionType.Boolean"
                                             [formControlName]="'field' + (index + 1)">
                                <ion-grid class="boolean">
                                    <ion-row>
                                        <ion-col size="8"></ion-col>
                                        <ion-col size="2"
                                                 *ngFor="let opValue of question.typeConfig.possibleValues; let typeIndex = index">
                                            <p>
                                                <b>
                                                    {{ question.typeConfig.possibleValuesGlobalized[selectedLanguage][typeIndex] | uppercase }}
                                                </b>
                                            </p>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="8">
                                            <p>{{ getText(question.globalizationConfig, "title") }}</p>
                                            <ng-container
                                                *ngIf="showRequiredBadge(coachingForm, (index + 1))">
                                                <p class="required">
                                                    ({{ "generic.obligatoryField" | translate }})
                                                </p>
                                            </ng-container>
                                        </ion-col>
                                        <ion-col
                                            size="2"
                                            *ngFor="
                                                        let opValue of question.typeConfig.possibleValues;
                                                        let vIndex = index
                                                      "
                                        >
                                            <ion-radio
                                                mode="md"
                                                [value]="opValue"
                                            ></ion-radio>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </ion-radio-group>

                            <ion-grid class="slider" *ngSwitchCase="QuestionType.Slider">
                                <ion-row>
                                    <ion-col size="1"></ion-col>
                                    <ion-col size="1"></ion-col>
                                    <!-- <ion-col size="1"></ion-col>
                                            <ion-col size="1"></ion-col> -->
                                    <ion-col
                                        *ngFor="
                                                        let opValue of question.typeConfig.possibleValues;
                                                        let vIndex = index
                                                    "
                                        [style.color]="question.typeConfig.colors[vIndex]"
                                    >
                                        <b>{{
                                                getText(question.typeConfig.possibleValuesGlobalized, vIndex)
                                            }}</b>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="2">
                                        <p
                                            [innerHtml]="
                                                              getParsedDescription(
                                                                getText(question.globalizationConfig, 'title')
                                                              )
                                                            "
                                            [ngClass]="{
                                                              highlight:
                                                                highlightSelfOrManagerEvalAnswer &&
                                                                question.type &&
                                                                (question.type === QuestionConfigType.GoalsFinalGrade ||
                                                                  question.type === QuestionConfigType.FinalGrade ||
                                                                  question.type === QuestionConfigType.PrinciplesFinalGrade ||
                                                                  question.type === QuestionConfigType.LeadershipFinalGrade)
                                                            }"
                                        ></p>
                                        <ng-container
                                            *ngIf="showRequiredBadge(coachingForm, (index + 1))"
                                        >
                                            <p class="required">
                                                ({{ "generic.obligatoryField" | translate }})
                                            </p>
                                        </ng-container>
                                    </ion-col>

                                    <ion-col
                                        *ngFor="
                                                        let opValue of question.typeConfig.possibleValues;
                                                        let vIndex = index
                                                      "
                                    >
                                        <div
                                            class="circle"
                                            [ngClass]="{
                                                      selected:
                                                        coachingForm.get('field' + (index + 1)).value === opValue
                                                    }"
                                            [style.borderColor]="question.typeConfig.colors[vIndex]"
                                            [style.backgroundColor]="
                                                  coachingForm.get('field' + (index + 1)).value === opValue
                                                    ? question.typeConfig.colors[vIndex]
                                                    : 'transparent'
                                                "
                                            (click)="setRangeValue('field' + (index + 1), opValue)"
                                        ></div>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>

                        </ng-container>
                        <br/>

                        <p
                            class="rejectComment"
                            *ngIf="coachingForm.get('field' + (index + 1) + 'Comment').value"
                        >
                            {{ coachingForm.get('field' + (index + 1) + 'Comment').value }}
                        </p>
                    </ng-container>
                </ng-container>
                <p class="rejectComment">
                    {{ coachingForm.get('managerComment').value }}
                </p>
            </form>
        </ion-item>

        <ion-card
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration && !hideGoalsOnGoalsReview && !isUserAttributesInsideConsentGoals"
            mode="ios"
            class="card-table-data"
        >
            <h4 class="goals-review">{{ 'goalsReview.goalsReview' | translate }}</h4>
            <ion-card-header>
                <ion-searchbar
                    mode="ios"
                    class="section-search-custom"
                    [placeholder]="'generic.searchByName' | translate"
                    (keyup)="updateSearch($event.target.value)"
                ></ion-searchbar>
                <ng-container *ngIf="canAddGoal(goals)">
                    <ion-button
                        mode="ios"
                        color="secondary"
                        (click)="openManageGoalsInputModal()"
                    >
                        {{ 'goalsInput.newGoalBtn' | translate }}
                    </ion-button>
                </ng-container>
            </ion-card-header>

            <ion-card-content class="ion-no-padding">
                <ion-grid class="table-view">
                    <ion-row hidden-mobile class="header">
                        <ion-col
                            *ngIf="inputConfig?.title || inputConfig?.description"
                            [sizeMd]="getColumnSize(inputConfig.questions.length)"
                        >
                            {{ 'generic.goal' | translate }}
                        </ion-col>
                        <ion-col *ngIf="inputConfig?.weight"
                                 [sizeMd]="getColumnSize(inputConfig.questions.length)">
                            {{ 'generic.weight' | translate }}
                        </ion-col>
                        <ion-col *ngIf="inputConfig?.deadline"
                                 [sizeMd]="getColumnSize(inputConfig.questions.length)">
                            {{ 'generic.deadline' | translate }}
                        </ion-col>
                        <ng-container *ngIf="inputConfig?.questions">
                            <ion-col
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                *ngFor="let question of inputConfig.questions"
                            >
                                {{ getText(question.globalizationConfig, 'title') }}
                            </ion-col>
                        </ng-container>
                        <ion-col
                            align-left
                            [sizeMd]="getColumnSize(inputConfig?.questions?.length)"
                        >
                            {{ 'generic.actions' | translate }}
                        </ion-col>
                    </ion-row>

                    <ion-row *ngFor="let goal of displayedGoals">
                        <!-- Previous Changes -->
                        <ng-container *ngIf="goal.lastVersion">
                            <ion-col
                                *ngIf="inputConfig?.title || inputConfig?.description"
                                size-xs="12"
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                class="ion-align-self-center"
                                faded
                            >
                                <div class="content">
                                    <p class="label-heading" hidden-desktop>
                                        {{ 'generic.goal' | translate }}
                                    </p>
                                    <h2>{{ goal.lastVersion.title }}</h2>
                                    <p class="underline-text">
                                        {{ goal.lastVersion.description }}
                                    </p>
                                </div>
                            </ion-col>
                            <ion-col
                                *ngIf="inputConfig?.weight"
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                faded
                            >
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.weight' | translate }}
                                </p>
                                {{ goal.lastVersion.weight }}%
                            </ion-col>
                            <ion-col
                                *ngIf="inputConfig?.deadline"
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                faded
                            >
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.deadline' | translate }}
                                </p>
                                {{ goal.lastVersion.deadline | date : 'dd/MM/yyyy' }}
                            </ion-col>
                            <ng-container *ngIf="inputConfig?.questions">
                                <ion-col
                                    class="ion-align-self-center"
                                    faded
                                    [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                    *ngFor="let question of inputConfig.questions; let index = index"
                                >
                                    <p class="label-heading" hidden-desktop>
                                        {{ getText(question.globalizationConfig, 'title') }}
                                    </p>
                                    <ng-container
                                        *ngIf="question.typeConfig.type === QuestionType.Date || question.typeConfig.type === QuestionType.Deadline"
                                    >
                                        {{
                                            goal.lastVersion['field' + (index + 1)] | translate |
                                                date:'dd/MM/yyyy'
                                        }}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="question.typeConfig.type === QuestionType.Weight"
                                    >
                                        {{ goal.lastVersion['field' + (index + 1)] | translate }} %
                                    </ng-container>
                                    <ng-container
                                        *ngIf="question.typeConfig.type !== QuestionType.Date &&
                                   question.typeConfig.type !== QuestionType.Weight &&
                                   question.typeConfig.type !== QuestionType.Deadline"
                                    >
                                        {{
                                            question.typeConfig?.possibleValuesGlobalized &&
                                            question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                            question.typeConfig?.possibleValues &&
                                            question.typeConfig?.possibleValues?.length > 0
                                                ?
                                                question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal.lastVersion['field' + (index + 1)])]
                                                :
                                                (goal.lastVersion['field' + (index + 1)] | translate)
                                        }}
                                    </ng-container>
                                </ion-col>
                            </ng-container>
                            <ion-col
                                align-right
                                class="ion-align-self-center"
                                size-xs="12"
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                faded
                            >
                                <p><b>{{ 'generic.beforeEditing' | translate }}</b></p>
                            </ion-col>
                        </ng-container>
                        <!-- Current Changes -->
                        <ion-col
                            *ngIf="inputConfig?.description"
                            size-xs="12"
                            [sizeMd]="getColumnSize(inputConfig.questions.length)"
                            class="ion-align-self-center"
                        >
                            <div class="content">
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.goal' | translate }}
                                </p>
                                <h2>{{ goal.title }}</h2>
                                <p class="underline-text">{{ goal.description }}</p>
                            </div>
                        </ion-col>
                        <ion-col *ngIf="inputConfig?.weight" class="ion-align-self-center"
                                 [sizeMd]="getColumnSize(inputConfig.questions.length)">
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.weight' | translate }}
                            </p>
                            {{ goal.weight }}%
                        </ion-col>
                        <ion-col
                            *ngIf="inputConfig?.deadline"
                            class="ion-align-self-center"
                            size-md="2"
                            [sizeMd]="getColumnSize(inputConfig.questions.length)"
                        >
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.deadline' | translate }}
                            </p>
                            {{ goal.deadline | date : 'dd/MM/yyyy' }}
                        </ion-col>

                        <ng-container *ngIf="inputConfig?.questions">
                            <ion-col
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                *ngFor="let question of inputConfig.questions; let index = index"
                            >
                                <p class="label-heading" hidden-desktop>
                                    {{ getText(question.globalizationConfig, 'title') }}
                                </p>
                                <ng-container
                                    *ngIf="question.typeConfig.type === QuestionType.Date || question.typeConfig.type === QuestionType.Deadline"
                                >
                                    {{
                                        goal['field' + (index + 1)] | translate | date:'dd/MM/yyyy'
                                    }}
                                </ng-container>
                                <ng-container
                                    *ngIf="question.typeConfig.type === QuestionType.Weight"
                                >
                                    {{ goal['field' + (index + 1)] | translate }} %
                                </ng-container>
                                <ng-container
                                    *ngIf="question.typeConfig.type !== QuestionType.Date &&
                                 question.typeConfig.type !== QuestionType.Weight &&
                                 question.typeConfig.type !== QuestionType.Deadline"
                                >
                                    {{
                                        question.typeConfig?.possibleValuesGlobalized &&
                                        question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                        question.typeConfig?.possibleValues &&
                                        question.typeConfig?.possibleValues?.length > 0
                                            ?
                                            question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal['field' + (index + 1)])]
                                            :
                                            (goal['field' + (index + 1)] | translate)
                                    }}
                                </ng-container>
                            </ion-col>
                        </ng-container>

                        <ion-col
                            align-right
                            class="ion-align-self-center"
                            size-xs="12"
                            [sizeMd]="getColumnSize(inputConfig.questions.length)"
                        >
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.actions' | translate }}
                            </p>
                            <div class="buttons">
                                <ng-container *ngIf="canEditGoals(goal.status)">
                                    <ion-button
                                        class="edit"
                                        color="primary"
                                        fill="clear"
                                        mode="ios"
                                        (click)="openManageGoalsInputModal(goal)"
                                    >
                                        <ion-icon class="bp-edit"></ion-icon>
                                    </ion-button>
                                </ng-container>

                                <ng-container *ngIf="canEditGoals(goal.status)">
                                    <ion-button
                                        class="delete"
                                        color="danger"
                                        fill="clear"
                                        mode="ios"
                                        (click)="confirmDeleteGoal(goal)"
                                    >
                                        <ion-icon class="bp-delete"></ion-icon>
                                    </ion-button>
                                </ng-container>
                                <ion-button
                                    color="success"
                                    fill="clear"
                                    mode="ios"
                                    *ngIf="getValidatedField(goal.status)"
                                >
                                    {{ 'generic.validated' | translate }}
                                    <ion-icon class="bp-check" slot="end"></ion-icon>
                                </ion-button>
                            </div>
                        </ion-col>
                        <ion-col size-md="12" *ngIf="goal.managerComment">
                            <p class="rejectComment">{{ goal.managerComment }}</p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>

        <div class="bottom-buttons ion-text-right">
            <ng-container *ngIf="canSaveReview">
                <ion-button
                    mode="ios"
                    color="primary"
                    class="save"
                    (click)="saveClicked()"
                >
                    {{ 'generic.save' | translate }}
                </ion-button>
            </ng-container>
            <ng-container *ngIf="canSubmitGoals">
                <ion-button
                    mode="ios"
                    color="secondary"
                    class="send"
                    (click)="submitGoals(goals)"
                >
                    {{ 'goalsReview.sendGoalsBtn' | translate }}
                </ion-button>
            </ng-container>
        </div>
    </div>
</ion-content>
